import {NgModule, ModuleWithProviders} from '@angular/core';

import {NgbTooltip, NgbTooltipWindow} from './tooltip';
import {NgbTooltipConfig} from './tooltip-config';

export {NgbTooltipConfig} from './tooltip-config';
export {NgbTooltip} from './tooltip';

@NgModule({ declarations: [NgbTooltip, NgbTooltipWindow], exports: [NgbTooltip] })
export class NgbTooltipModule {
  static forRoot(): ModuleWithProviders<NgbTooltipModule> { return {ngModule: NgbTooltipModule, providers: [NgbTooltipConfig]}; }
}
